import BrandColors from "../../styles/BrandColors";
const { JLLBrandColors } = BrandColors;
const { ComponentColors } = JLLBrandColors;
const { ScoreIndicators } = ComponentColors;

export default (theme) => ({
  borderedSquare: {
    position: "relative",
    display: "block",
    minHeight: "20px",
    minWidth: "20px",
    maxHeight: "20px",
    maxWidth: "20px",
    boxSizing: "border-box",
    borderRadius: "10px",
    marginRight: "10px",
    fontSize: "20px",
  },
  crossed: {
    overflow: "hidden",
    "&:after": {
      position: "absolute",
      content: '""',
      display: "block",
      width: "100%",
      height: "2px",
      transform: "rotate(45deg)",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      margin: "auto",
      background: "white",
    },
    "&:before": {
      position: "absolute",
      content: '""',
      display: "block",
      width: "100%",
      height: "2px",
      transform: "rotate(-45deg)",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      margin: "auto",
      background: "white",
    },
  },
  verticalCenter: {
    margin: 0,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
  },
  scoreBlocked: {
    backgroundColor: ScoreIndicators.block,
  },
  scoreHigh: {
    backgroundColor: ScoreIndicators.high,
  },
  scoreMedium: {
    backgroundColor: ScoreIndicators.medium,
  },
  scoreLow: {
    backgroundColor: ScoreIndicators.low,
  },
  noScore: {
    backgroundColor: ScoreIndicators.noScore,
  },
  expiredScore: {
    backgroundColor: ScoreIndicators.expired,
  },
  label: {
    fontSize: 13,
    fontWeight: 400,
    color: "#898B8E",
  },
});
